<script>
  export let width;
  export let height;
</script>

<rect x={0} y={0} {width} {height} fill={"#ffe2d9"} />
<text x={width / 2} y={height / 3} text-anchor={"middle"} fill={"#a3320f"}
  >No data available for this combination of year and indicators</text
>
<text x={width / 2} y={height / 3 + 20} text-anchor={"middle"} fill={"#a3320f"}
  >Select another year or check "Show most recent year available"</text
>
